<app-grouped-datatable
  class="campaign-details-deliverables-table"
  [style.display]="groupedMode() ? null : 'none'"
  [groups]="groupedMode() ? groupedRowData() : []"
  [totalParentCount]="groupedMode() ? groupedRowData().length : 0"
  [parentColumns]="groupedParentColumns()"
  [childColumns]="groupedChildColumns()"
  [customParentColumnDef]="groupedParentCustomColumns()"
  [customChildColumnDef]="groupedChildCustomColumns()"
  [configurationInput]="groupedConfiguration()"
  [isInitialDataLoaded]="!loading()"
  [loadingData]="loading()"
  [loaderConfig]="groupedSkeletonLoaderConfig()"
  [currentTab]="currentTab"
  (childRowClick)="onGroupedChildRowClicked($event.child)"
/>

<app-datatable
  class="campaign-details-deliverables-table"
  [style.display]="groupedMode() ? 'none' : null"
  [columns]="columns()"
  [configurationInput]="configuration()"
  [customColumnDef]="customColumns()"
  [loaderConfig]="skeletonLoaderConfig()"
  [isInitialDataLoaded]="!loading()"
  [loadingData]="loading()"
  [rowData]="groupedMode() ? [] : rowData()"
  [total]="groupedMode() ? 0 : rowData().length"
  (rowClick)="rowClicked.emit($event.row)"
/>

<ng-template #statusColumn let-row="row">
  <app-status-badge [colorScheme]="row.rowStatusColorScheme" [status]="row.rowStatus" />
</ng-template>

<ng-template #deliverableGroupColumn let-row="row">
  <div class="flex items-center gap-2">
    <app-social-badge
      backgroundColor="transparent"
      [type]="row.platformFeature"
      [size]="16"
      [iconSize]="16"
      [iconHasPlatformColor]="true"
    />
    <span
      class="line-clamp-1 text-ellipsis"
      matTooltip
      matTooltipPosition="above"
      [appTextClampTooltip]="row.ctaTemplateName"
    >
      {{ row.ctaTemplateName }}
    </span>
  </div>
</ng-template>

<ng-template #groupedDeliverableGroupColumn let-row="row">
  <button
    type="button"
    class="flex items-center gap-2 rounded-full px-2 py-0.5"
    [class.hover:bg-shikenso-pink-base-12]="campaignExportConfig().allowDeliverableGroupClick"
    [disabled]="!campaignExportConfig().allowDeliverableGroupClick"
    (click)="onGroupedDeliverableGroupClicked($event, row)"
  >
    <app-social-badge
      backgroundColor="transparent"
      [type]="row.platformFeature"
      [size]="16"
      [iconSize]="16"
      [iconHasPlatformColor]="true"
    />
    <span
      class="line-clamp-1 text-ellipsis"
      matTooltip
      matTooltipPosition="above"
      [appTextClampTooltip]="row.ctaTemplateName"
    >
      {{ row.ctaTemplateName }}
    </span>
  </button>
</ng-template>

<ng-template #deliverableColumn let-row="row">
  <span
    class="line-clamp-1 text-ellipsis"
    matTooltip
    matTooltipPosition="above"
    [appTextClampTooltip]="row.deliverableName"
  >
    {{ row.deliverableName }}
  </span>
</ng-template>

<ng-template #groupedDeliverableColumn let-row="row">
  <span
    class="line-clamp-1 text-ellipsis"
    matTooltip
    matTooltipPosition="above"
    [appTextClampTooltip]="row.sourceRow.deliverableName"
  >
    {{ row.sourceRow.deliverableName }}
  </span>
</ng-template>

<ng-template #groupedChildIndicatorColumn>
  <div class="flex items-center justify-center">
    <app-icon src="/icons/corner-down-right.svg" alt="Deliverable" [size]="14" />
  </div>
</ng-template>

<ng-template #creatorColumn let-row="row">
  <div class="flex min-w-0 items-center gap-2">
    <app-icon-badge
      backgroundColor="var(--shikenso-base-white)"
      fallbackBackgroundColor="var(--shikenso-gray-base)"
      [borderRadius]="100"
      [content]="row.creatorIcon"
      [fallbackText]="row.creatorName"
      [fontSize]="12"
      [iconSize]="24"
      [size]="24"
    />
    <span
      class="line-clamp-1 text-ellipsis"
      matTooltip
      matTooltipPosition="above"
      [appTextClampTooltip]="row.creatorName"
    >
      {{ row.creatorName }}
    </span>
  </div>
</ng-template>

<ng-template #campaignColumn let-row="row">
  <button
    type="button"
    class="flex min-w-0 items-center gap-2 rounded-full px-2 py-0.5"
    [class.hover:bg-shikenso-pink-base-12]="!!row.campaignId"
    [disabled]="!row.campaignId"
    (click)="onCampaignClicked($event, row)"
  >
    <app-icon-badge
      backgroundColor="var(--shikenso-base-white)"
      fallbackBackgroundColor="var(--shikenso-gray-base)"
      [borderRadius]="100"
      [content]="row.campaignIcon"
      [fallbackText]="row.campaignName"
      [fontSize]="12"
      [iconSize]="24"
      [size]="24"
    />
    <span
      class="line-clamp-1 max-w-[180px] text-ellipsis"
      matTooltip
      matTooltipPosition="above"
      [appTextClampTooltip]="row.campaignName"
    >
      {{ row.campaignName }}
    </span>
  </button>
</ng-template>

<ng-template #matchingStatusColumn let-row="row">
  <app-status-badge colorScheme="matching-status" size="medium" [status]="row.matchingType" />
</ng-template>

<ng-template #deliverablesCountColumn let-row="row">
  <span>{{ row.deliverablesCount }}</span>
</ng-template>

<ng-template #dateColumn let-row="row">
  <div class="flex items-center gap-2">
    <app-icon src="/icons/calendar-event.svg" alt="Calendar" [size]="16" />
    <span>{{ row.dateLabel || '-' }}</span>
  </div>
</ng-template>
